
import img1 from '../images/layouts/banner-07.webp'
import img2 from '../images/layouts/banner-08.webp'
import img3 from '../images/layouts/banner-09.webp'
import img4 from '../images/layouts/banner-11.webp'

import avt from '../images/layouts/avt-05.png'



const dataCard = [

    {
        id: 1,
        img: img1,
        title: '3D Digital Artwork',
        price : '2.26 Credit',
        avt: avt,
        name: 'Toyki',
        tag: '@toyki_official'
    },
    {
        id: 2,
        img: img2,
        title: '3D Digital Artwork',
        price : '2.26 Credit',
        avt: avt,
        name: 'shin yeongbin',
        tag: '@sinobin_'
    },
    {
        id: 3,
        img: img3,
        title: '3D Digital Artwork',
        price : '1.82 Credit',
        avt: avt,
        name: 'shin sanghyun',
        tag: '@hot._.hyun'
    },
    {
        id: 4,
        img: img4,
        title: '3D Digital Artwork',
        price : '1.82 Credit',
        avt: avt,
        name: 'kim minseung',
        tag: '@rkms027'
    },

]

export default dataCard;